import { render, staticRenderFns } from "./TaskNewFrGroup.vue?vue&type=template&id=c8d9a426"
import script from "./TaskNewFrGroup.vue?vue&type=script&lang=js"
export * from "./TaskNewFrGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports